interface ITmrParams {
    [key: string]: string | number;
}
export const pushTmr = (tmrParams: ITmrParams) => {
    const _tmr = window._tmr || (window._tmr = []);
    _tmr.push(tmrParams);
};
